import { EmptyState } from "@/ui/states";
import { type Deadline, deadlineLeft, deadlineTone, shortDate, sortDeadlines } from "./derive";

const TONE: Record<ReturnType<typeof deadlineTone>, string> = {
  err: "text-err",
  warn: "text-warn",
  ink2: "text-ink2",
  mut: "text-mut",
};

export function NoCohortDeadlines({ where = "студент · дедлайны" }: { where?: string }) {
  return <EmptyState where={where} title="Дедлайнов пока нет" body="Ты идёшь вне когорты — сроки появятся, когда админ соберёт поток." />;
}

/** «Ближайшие дедлайны» (S1): дата · название и трек · сколько осталось. */
export function DeadlinesCard({ deadlines, cohort, compact = false }: { deadlines: Deadline[]; cohort?: string; compact?: boolean }) {
  if (!cohort) return <NoCohortDeadlines />;
  const list = sortDeadlines(deadlines);
  return (
    <div className="overflow-hidden rounded-md border border-bd bg-card" data-testid="deadlines">
      {!compact && <div className="border-b border-bd px-4 py-[11px] font-mono text-[11px] uppercase tracking-[.06em] text-mut">ближайшие дедлайны</div>}
      {list.length === 0 ? (
        <p className="m-0 px-4 py-5 text-[13px] text-ink2">В когорте пока не назначены сроки — появятся, когда админ их проставит.</p>
      ) : (
        <ul className="m-0 list-none p-0">
          {list.map((d) => {
            const tone = TONE[deadlineTone(d.days_left)];
            return (
              <li key={`${d.step_id}-${d.kind}-${d.date}`} className={`grid items-center gap-3 border-b border-bd last:border-b-0 ${compact ? "grid-cols-[46px_minmax(0,1fr)] px-3 py-2.5" : "grid-cols-[52px_minmax(0,1fr)_auto] px-4 py-[11px]"}`}>
                <span className={`font-mono text-[12px] ${tone}`}>{shortDate(d.date)}</span>
                <div className="min-w-0">
                  <div className={`text-[13px] text-ink ${compact ? "leading-[1.35] text-pretty" : "overflow-hidden text-ellipsis whitespace-nowrap"}`}>{d.title}</div>
                  <div className="mt-0.5 font-mono text-[11px] text-mut">
                    {d.track}
                    {compact && <> · {deadlineLeft(d.days_left)}</>}
                  </div>
                </div>
                {!compact && <span className={`whitespace-nowrap font-mono text-[11px] ${tone}`}>{deadlineLeft(d.days_left)}</span>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
